import React from 'react';
import { Form, InputGroup, Button } from 'react-bootstrap';
import Calendar from 'react-calendar';
import { FaClock, FaInfinity, FaCalendar, FaWallet, FaUsers } from 'react-icons/fa';
import './CouponLimits.scss';

interface CouponLimitsProps {
  limitType: string;
  setLimitType: (val: string) => void;
  selectedExpirationDate: Date | null;
  setSelectedExpirationDate: (date: Date | null) => void;
  showCalendar: boolean;
  setShowCalendar: (val: boolean) => void;
  maxBudget: number | null;
  setMaxBudget: (val: number | null) => void;
  maxNumber: number | null;
  setMaxNumber: (val: number | null) => void;
}

const CouponLimits: React.FC<CouponLimitsProps> = ({
  limitType,
  setLimitType,
  selectedExpirationDate,
  setSelectedExpirationDate,
  showCalendar,
  setShowCalendar,
  maxBudget,
  setMaxBudget,
  maxNumber,
  setMaxNumber
}) => {
  return (
    <div className="form-section limit-section">
      <div className="section-title">
        <FaClock className="section-icon" />
        Límites y restricciones
      </div>

      <div className="limit-options">
        <div
          className={`limit-option ${limitType === 'Sin limite' ? 'active' : ''}`}
          onClick={() => setLimitType('Sin limite')}
        >
          <div className="limit-header">
            <div className="limit-icon">
              <FaInfinity />
            </div>
            <div className="limit-title">Sin límite</div>
          </div>
          <div className="limit-description">Puede usarse indefinidamente</div>
        </div>

        <div
          className={`limit-option ${limitType === 'Fecha Expiración' ? 'active' : ''}`}
          onClick={() => setLimitType('Fecha Expiración')}
        >
          <div className="limit-header">
            <div className="limit-icon">
              <FaCalendar />
            </div>
            <div className="limit-title">Fecha límite</div>
          </div>
          <div className="limit-description">Expira en fecha específica</div>
        </div>

        <div
          className={`limit-option ${limitType === 'Presupuesto' ? 'active' : ''}`}
          onClick={() => setLimitType('Presupuesto')}
        >
          <div className="limit-header">
            <div className="limit-icon">
              <FaWallet />
            </div>
            <div className="limit-title">Presupuesto máximo</div>
          </div>
          <div className="limit-description">Se desactiva al alcanzar monto total</div>
        </div>

        <div
          className={`limit-option ${limitType === 'Número de Usos' ? 'active' : ''}`}
          onClick={() => setLimitType('Número de Usos')}
        >
          <div className="limit-header">
            <div className="limit-icon">
              <FaUsers />
            </div>
            <div className="limit-title">Número de usos</div>
          </div>
          <div className="limit-description">Se desactiva después de cierta cantidad</div>
        </div>
      </div>

      <div className="limit-inputs">
        {(limitType === 'Fecha Expiración' || limitType === 'Presupuesto y Fecha de Expiración') && (
          <div className="calendar-container">
            <Form.Group className="mp-formgroup horizontal">
              <Form.Label>Fecha de expiración:</Form.Label>
              <Button
                variant="none"
                onClick={() => setShowCalendar(!showCalendar)}
                className="boton-show-calendar-coupons"
              >
                {selectedExpirationDate
                  ? selectedExpirationDate.toLocaleDateString()
                  : 'Seleccionar fecha'}
                <FaCalendar />
              </Button>
            </Form.Group>

            {showCalendar && (
              <div className="mp-form-calendar-container">
                <Calendar
                  onChange={(date) => {
                    setSelectedExpirationDate(date as Date);
                    setShowCalendar(false);
                  }}
                  value={selectedExpirationDate}
                  locale="es-ES"
                  className="mp-form-calendar"
                  minDate={new Date()}
                />
              </div>
            )}
          </div>
        )}

        {limitType === 'Presupuesto' && (
          <Form.Group className="mp-formgroup horizontal">
            <Form.Label>Monto máximo total:</Form.Label>
            <InputGroup>
              <InputGroup.Text className="signo">$</InputGroup.Text>
              <Form.Control
                type="number"
                min="0"
                value={maxBudget || ''}
                onChange={(e) => setMaxBudget(Math.max(0, Number(e.target.value)))}
                required
                placeholder="Ej: 50000"
              />
            </InputGroup>
          </Form.Group>
        )}

        {limitType === 'Número de Usos' && (
          <Form.Group className="mp-formgroup horizontal">
            <Form.Label>Número máximo de usos:</Form.Label>
            <Form.Control
              type="number"
              min="1"
              value={maxNumber !== null ? maxNumber : ''}
              onChange={(e) => setMaxNumber(Math.max(1, Number(e.target.value)))}
              required
              placeholder="Ej: 100"
            />
          </Form.Group>
        )}
      </div>
    </div>
  );
};

export default CouponLimits;
